// extracted by mini-css-extract-plugin
export default {"month-selector":"IX2id","month-selector__item":"LeQpz","month-selector__item_active":"ZyiSj"};